import { useContext } from 'react'
import { ZoneContext } from '../context/zoneContext'

export const useZoneContext = () => useContext(ZoneContext)
export default useZoneContext